const showMailBox = () => {
  document.getElementById('mailError').classList.add('d-none');
  document.getElementById('mailBox').classList.remove('d-none');
};

document.getElementsByClassName('showMailBoxButton')[0].addEventListener('click', () => (showMailBox));

document.getElementById('sendMail').addEventListener('click', (event) => {
  event.preventDefault();

  const form = document.getElementById('mailForm');
  if (!form.checkValidity()) {
    event.preventDefault();
    event.stopPropagation();
  }

  form.classList.add('was-validated');
  const data = new URLSearchParams(new FormData(form));

  fetch(form.getAttribute('action'), {
    method: 'post',
    body: data,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data === 'error') {
        document.getElementById('mailBox').classList.add('d-none');
        document.getElementById('mailError').classList.remove('d-none');
      } else {
        document.getElementById('mailBox').classList.add('d-none');
        document.getElementById('mailSuccess').classList.remove('d-none');
      }
    });
});
